import { BaseMemberProps } from "@custom-types/base-types";
import { ReactSetStateFunction } from "@utils/utility-types";
import { DeleteMemberStep1 } from "@components/delete-member/delete-member-step1";
import { DeleteMemberStep2 } from "@components/delete-member/delete-member-step2";
import { DeleteMemberStep3 } from "@components/delete-member/delete-member-step3";

interface Props extends BaseMemberProps {
  /** Setter for disableContinue */
  setShouldDisableContinueButton: ReactSetStateFunction<boolean>;
}

/** Returns the steps for deleting a member */
export function deleteMemberSteps({
  member,
  setShouldDisableContinueButton,
}: Props): Array<{ label: string; content: React.JSX.Element }> {
  return [
    {
      label: "Review Deletion Guidelines",
      content: (
        <DeleteMemberStep1
          setShouldDisableContinueButton={setShouldDisableContinueButton}
        />
      ),
    },
    {
      label: "Member's workspaces",
      content: (
        <DeleteMemberStep2
          companies={member.companies}
          member={member}
          setShouldDisableContinueButton={setShouldDisableContinueButton}
        />
      ),
    },
    {
      label: "Final Confirmation",
      content: (
        <DeleteMemberStep3
          membersEmail={member.email}
          setShouldDisableContinueButton={setShouldDisableContinueButton}
        />
      ),
    },
  ];
}
